import { getContext, setContext } from 'svelte';
import { type Writable, writable } from 'svelte/store';

const STORE_KEY = Symbol('expense-note');

export type ComputeMethod = 'allowance' | 'real';

export interface ExpenseNote {
	mileageAllowance: string;
	includeTolls: boolean;
	includeVignettes: boolean;
	includeEnergy: boolean;
	identity: string;
	date: string;
	additionalInfo: string;
	energyCostPerUnit: string;
	computeMethod: ComputeMethod;
}

export function createExpenseNoteContext(locale: string) {
	const expenseNote: Writable<ExpenseNote> = writable({
		mileageAllowance: '0',
		includeTolls: false,
		includeVignettes: false,
		includeEnergy: false,
		identity: '',
		date: new Intl.DateTimeFormat(locale, {
			year: 'numeric',
			month: 'long',
			day: 'numeric',
		}).format(new Date()),
		additionalInfo: '',
		energyCostPerUnit: '0',
		computeMethod: 'allowance',
	});
	setContext(STORE_KEY, expenseNote);
}

export function getExpenseNoteContext() {
	return getContext<Writable<ExpenseNote>>(STORE_KEY);
}
